import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import BusinessContent from "./pages/BusinessContent";
import DirectorPage from "./pages/DirectorPage";
import EditingPage from "./pages/EditingPage";
import Header from "./components/Header";
import Home from "./pages/Home";
import PortfolioPage from "./pages/PortfolioPage";
import Work from "./pages/Work";
import "./App.css";
import "./styles/Home.css";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const hideHeader = pathname === "/portfolio";

  return (
    <div className="appMain">
      <ScrollToTop />
      {hideHeader ? null : <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="/business" element={<BusinessContent />} />
        <Route path="/director" element={<DirectorPage />} />
        <Route path="/editing" element={<EditingPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/artists" element={<Navigate to="/work" replace />} />
        <Route path="/creators" element={<Navigate to="/work" replace />} />
        <Route path="/director-work" element={<Navigate to="/work" replace />} />
        <Route path="/brand-creator-work" element={<Navigate to="/work" replace />} />
        <Route path="/business-content" element={<Navigate to="/business" replace />} />
        <Route path="/social-growth" element={<Navigate to="/business" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
